import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

export const theme = resolveConfig(tailwindConfig).theme;

export const viewportPercentage = function (elem) {
    const bounding = elem.getBoundingClientRect();
    const percentage =
        (bounding.top / window.innerHeight || document.documentElement.clientHeight) * 100;
    return percentage >= 0 && percentage <= 100 ? percentage : false;
};
